import { lenis } from './scroll.js';

// Hoogte van eventuele sticky-header die we willen vermijden bij anker-scroll.
const HEADER_OFFSET = 100;

function getHashTarget( href ) {
	if ( ! href || href.charAt( 0 ) !== '#' ) {
		return null;
	}
	if ( href === '#' ) {
		return null;
	}
	try {
		return document.querySelector( href );
	} catch ( _e ) {
		// Ongeldige selector (bv. `#1foo`) — laat browser-default afhandelen.
		return null;
	}
}

function handleClick( e ) {
	// Negeer modified clicks (cmd/ctrl/shift) zodat new-tab gedrag werkt.
	if ( e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey ) {
		return;
	}

	const link = e.target.closest( 'a[href]' );
	if ( ! link ) {
		return;
	}

	const href = link.getAttribute( 'href' );
	if ( ! href || href.charAt( 0 ) !== '#' ) {
		return;
	}

	const target = getHashTarget( href );
	if ( ! target ) {
		// Anker bestaat niet — geen JS-actie, laat browser scrollen naar top.
		return;
	}

	e.preventDefault();

	if ( lenis ) {
		lenis.scrollTo( target, { offset: -HEADER_OFFSET } );
	} else {
		// Block-editor preview / customizer: Lenis bestaat niet, val terug op
		// native smooth-scroll.
		target.scrollIntoView( { behavior: 'smooth', block: 'start' } );
	}

	if ( window.history && typeof window.history.replaceState === 'function' ) {
		window.history.replaceState( null, '', href );
	}
}

document.addEventListener( 'click', handleClick );

export {};
